/* unplugin-vue-components disabled */import script from "./videoplayer.vue?vue&type=script&lang=js"
export * from "./videoplayer.vue?vue&type=script&lang=js"

import "./videoplayer.vue?vue&type=style&index=0&id=298661e8&lang=scss"

const __exports__ = script;

export default __exports__